import { render, staticRenderFns } from "./indicadorBottomComponent.vue?vue&type=template&id=dfea59fa&"
import script from "./indicadorBottomComponent.vue?vue&type=script&lang=js&"
export * from "./indicadorBottomComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VChip } from 'vuetify/lib/components/VChip';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomNavigation,VChip,VLayout})
